import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"

export default function ExpensesPage() {
  const expenses = [
    { id: 1, desc: "Luz Edesur", amount: "$5,400", date: "10 Oct 2026", cat: "Servicios" },
    { id: 2, desc: "Cajas de envío", amount: "$12,000", date: "05 Oct 2026", cat: "Insumos" },
  ]

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight">Gastos</h2>
        <Button>Agregar Gasto</Button>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm text-muted-foreground">Total del Mes</CardTitle></CardHeader>
          <CardContent><p className="text-3xl font-bold">$17,400</p></CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader><CardTitle>Historial de Gastos</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-4">
            {expenses.map(e => (
              <div key={e.id} className="flex justify-between items-center border-b pb-4 last:border-0 last:pb-0">
                <div>
                  <p className="font-medium">{e.desc}</p>
                  <p className="text-sm text-muted-foreground">{e.date} • {e.cat}</p>
                </div>
                <p className="font-medium text-destructive">{e.amount}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
